import {
  AppSetupAction,
  APP_SETUP_COMPLETE,
  APP_SETUP_RESET,
  APP_SETUP_ERROR,
} from "./actionTypes";

interface AppSetupState {
  appSetupComplete: boolean;
  appSetupError?: Error;
}

const INITIAL_STATE: AppSetupState = {
  appSetupComplete: false,
  appSetupError: undefined,
};

export function reducer(
  state = INITIAL_STATE,
  action: AppSetupAction
): AppSetupState {
  switch (action.type) {
    case APP_SETUP_COMPLETE:
      return {
        ...state,
        appSetupComplete: true,
        appSetupError: undefined,
      };
    case APP_SETUP_ERROR:
      return {
        ...state,
        appSetupComplete: false,
        appSetupError: action.error,
      };
    case APP_SETUP_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
}
